<div class="cup-results-row">
  <div class="place-column">#</div>
  <div class="player-column">Player</div>
  <div class="points-column">Points</div>
  <div class="rating-column">Rating</div>
</div>
<div *ngFor="let result of table; let i = index" class="cup-results-row">
  <div class="place-column">
    <app-player-place [place]="places[i]"></app-player-place>
  </div>
  <div class="player-column">
    <app-player-cell [country]="result.country" [nick]="result.nick" [playerId]="result.playerId"> </app-player-cell>
  </div>
  <div class="points-column" data-test-id="text-player-points">{{ result.finalSum }}</div>
  <div class="rating-column">
    <app-rating-change [change]="physics === allPhysics.CPM ? result.cpmChange : result.vq3Change"></app-rating-change>
  </div>
</div>

<div class="full-table-link">
  <a (click)="navigateToOnlineCupTable()" class="pointer">
    <span translate translation="fullTable"></span>
  </a>
</div>
